function dynamicTestId(prefix: string, value: string): string {
  return `${prefix}-${value.replace(' ', '-').toLowerCase()}`;
}

export default dynamicTestId;
